import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}
export function Tooltip({
  content,
  children,
  position = 'top'
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };
  return <div className="relative inline-block" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} onFocus={() => setIsVisible(true)} onBlur={() => setIsVisible(false)} data-id="element-1729">
      {children}
      <AnimatePresence data-id="element-1730">
        {isVisible && <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: position === 'top' ? 5 : -5
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: position === 'top' ? 5 : -5
      }} transition={{
        duration: 0.15,
        ease: 'easeOut'
      }} className={`absolute z-50 ${positionClasses[position]}`} data-id="element-1731">
            <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-xl max-w-xs" data-id="element-1732">
              <div className="relative z-10" data-id="element-1733">{content}</div>
              {/* Arrow */}
              <div className={`absolute w-2 h-2 bg-gray-900 transform rotate-45 ${position === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2' : position === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2' : position === 'left' ? 'right-[-4px] top-1/2 -translate-y-1/2' : 'left-[-4px] top-1/2 -translate-y-1/2'}`} data-id="element-1734" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}